import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/integration-systems/integration-app-bar/integration-app-bar.js';
      

      export interface Props {
     
   }

      

      

      
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcIntegrationAppBar',
  setup(__props) {

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        

        return h(
          'obc-integration-app-bar',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})